import { isError, noop } from 'lodash';
import { memo } from 'react';
import { object } from 'yup';

import { InlineInput, type InlineInputProps } from '@air/component-inline-input';

import { EDITABLE_TABLE_TITLE_INPUT_ID } from '~/components/TableView/PrivateTableView/rowUtils';
import { ItemNameValidation } from '~/utils/validationSchemas';

export type EditableTableTitleProps = {
  title: string;
  setIsRenaming?: (nextIsRenaming: boolean) => void;
  onRenameComplete: Required<InlineInputProps>['onSubmit'];
};

const EDITING_CLEARANCE = 200;

const TitleValidationSchema = object({
  title: ItemNameValidation,
});

const validateTitle = (value: string) => {
  try {
    TitleValidationSchema.validateSync({ title: value });
  } catch (error) {
    return isError(error) ? error.message : 'Invalid title';
  }
};

export const EditableTableTitle = memo(({ title, setIsRenaming = noop, onRenameComplete }: EditableTableTitleProps) => (
  <InlineInput
    id={EDITABLE_TABLE_TITLE_INPUT_ID}
    rows={1}
    allowNewLines={false}
    label="Row name"
    autoFocus
    data-testid="TABLE_TITLE_INPUT"
    defaultValue={title}
    onSubmit={onRenameComplete}
    onCancel={() => setIsRenaming(false)}
    validate={validateTitle}
    className="ml-[-5px] w-full"
    inputClassName="px-1 font-medium py-1"
    style={{
      minWidth: EDITING_CLEARANCE,
    }}
  />
));

EditableTableTitle.displayName = 'EditableTableTitle';
